import React, { useState ,useRef,useEffect} from 'react';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../software-dynamic-version-6/mainSection-multiple-inputs-v-6';
import buyerService from './buyer.service';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';

const BuyerAdd = (props) => {
 
   let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};

  const updateMainSecionsValue = (valueObj) => {
    setInputProps((prevValues) => {
      const updatedValues = { ...prevValues };
      Object.keys(valueObj).forEach((key) => {
        if (updatedValues[key]) {
          updatedValues[key] = {
            ...updatedValues[key],
            ...valueObj[key],
          };
        }
      });
      return updatedValues;
    });
  };
  const optionalCols = props.optionalColumns || [];
  const has = (c) => optionalCols.includes(c);
  
  const [inputProps, setInputProps] = useState({
    buyerNTNCNIC: {
      name: 'buyerNTNCNIC',
      caption: 'Buyer NTN/CNIC',
      value: props.buyerNTNCNIC || '',
      enabled:props.isAdd
    },
    buyerBusinessName: {
      name: 'buyerBusinessName',
      caption: 'Buyer Business Name',
      value: props.buyerBusinessName || ''
    },
    stateProvinceName: {
      name: { id: 'stateProvinceCode', value: 'stateProvinceName' },
      caption: 'Select Province',
      value: {
        id: props.buyerProvinceCode || '',
        value: props.buyerProvinceName || ''
      },
      dataSource: { type: 'Data', data: [] }
    },
    buyerAddress: {
      name: 'buyerAddress',
      caption: 'Buyer Address',
      value: props.buyerAddress || ''
    },
    buyerRegistrationType: {
      name: 'buyerRegistrationType',
      caption: 'Buyer Registration Type',
      value: props.buyerRegistrationType || null
    },
    sellerNTNCNIC: {
      name: 'sellerNTNCNIC',
      caption: 'Seller NTN/CNIC',
      value: props.sellerNTNCNIC || null
    },
    buyerContactPerson: {name: "buyerContactPerson", caption: "Contact Person", value: props.buyerContactPerson || ""},
buyerContactNumber: {name: "buyerContactNumber", caption: "Contact Number", value: props.buyerContactNumber || ""},
buyerSTRN: {name: "buyerSTRN", caption: "Buyer STRN", value: props.buyerSTRN || ""},
buyerCNIC: {name: "buyerCNIC", caption: "Buyer CNIC", value: props.buyerCNIC || ""},
  });


  useEffect(()=>{
    return ()=>{
    hideTooltip(); // remove previous tooltip
    }
  },[])
  const getProvincesSource = async () => {
    const response = await buyerService.getCompanyView();
    const { data } = await buyerService.getProvincesDD(response.data.recordset[0].CompanyID);
    console.log(data)
    const recordsMapping = (data || []).map((row) => ({
      id: row.stateProvinceCode,
      value: row.stateProvinceDesc
    }));

    updateMainSecionsValue({
      stateProvinceName: {
        dataSource: { type: 'Data', data: recordsMapping }
      }
    });
    setTimeout(() => {
      
      if(props.isAdd == false){
        updateMainSecionsValue({
          stateProvinceName: {
            value:{ value:{ id: props.buyerProvinceCode, value: props.buyerProvinceName }}
          }
        });
      }
    }, 500);
  };


  // ==================================================
// 🔥 Validate Buyer NTN (7 chars, alphanumeric only)
// ==================================================

  
const tooltipRef = useRef(null);

const showTooltip = (target, message) => {
   if (tooltipRef.current) {
     tooltipRef.current.destroy(); // Destroy existing tooltip if any
   }
   tooltipRef.current = new TooltipComponent({
     content: `<span class="error-tooltip">${message}</span>`,
     position: 'TopCenter',
   });
   tooltipRef.current.appendTo(target);
   tooltipRef.current.open(target);
 };
 
 const hideTooltip = () => {
   if (tooltipRef.current) {
     try {
       // Check if close method exists and tooltip is still mounted
       if (tooltipRef.current.close && typeof tooltipRef.current.close === 'function') {
         tooltipRef.current.close();
       }
       // Check if destroy method exists and tooltip is still mounted
       if (tooltipRef.current.destroy && typeof tooltipRef.current.destroy === 'function') {
         tooltipRef.current.destroy();
       }
     } catch (error) {
       // Silently handle errors when tooltip is already unmounted
       console.warn('Tooltip cleanup error (safe to ignore):', error.message);
     } finally {
       // Always reset the ref regardless of success/failure
       tooltipRef.current = null;
     }
   }
 };


 const SaveButton = (GridID, visibility) => {
  const btn = document.querySelector(`#${GridID}Grid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat`);
  if (btn) btn.style.visibility = `${visibility}`;
}

const validateBuyerNTN = (value, inputId = "buyerNTNCNIC") => {

  const inputField = document.getElementById(inputId);
  if (!inputField) return false;
  
  setTimeout(() => { SaveButton(props.GridID, 'visible'); }, 100);
  hideTooltip(); // remove previous tooltip

  if (!value) {
    showTooltip(inputField, "Buyer NTN is required");
    inputField.focus();
    // setTimeout(() => { SaveButton(props.GridID, 'hidden'); }, 100);
    return false;
  }


  // --- remove all characters except A-Z and 0-9 ---
  const cleanValue = value.replace(/[^A-Za-z0-9]/g, "");

  // update field if characters were removed
  if (cleanValue !== value) {
    inputField.value = cleanValue;
  }

  // --- allow only 7 characters ---
  if (cleanValue.length <  7) {
    showTooltip(inputField, "NTN must be exactly 7 alphanumeric characters");
    // inputField.focus();
    // setTimeout(() => { SaveButton(props.GridID, 'hidden'); }, 100);
    return false;
  }
  if (cleanValue.length > 7 &&  cleanValue.length !== 13) {
    showTooltip(inputField, "CNIC must be exactly 13 alphanumeric characters");
    // inputField.focus();
    // setTimeout(() => { SaveButton(props.GridID, 'hidden'); }, 100);
    return false;
  }
  if(cleanValue.length > 13){
    setTimeout(() => { SaveButton(props.GridID, 'hidden'); }, 100);
    return false;
  }

  setTimeout(() => { SaveButton(props.GridID, 'visible'); }, 100);
  return true; 
};

  const handleInputCreated = async (e, name) => {
    if (name === 'stateProvinceName') {
      getProvincesSource();
    }
    console.log(`Input ${name} created`, e);
  };


  const handleInputChange = async (value, name) => {
    console.log(value)
    if(name == 'buyerNTNCNIC'){
      validateBuyerNTN(value);
    }
  }
  const inputsList = [
    { Input: TextComponent, Props: { ...inputProps.buyerNTNCNIC, setInputProps,onChange:handleInputChange }, ColumnSize: 6 },
    { Input: TextComponent, Props: { ...inputProps.buyerBusinessName, setInputProps }, ColumnSize: 6 },
    {
      Input: DropdownComponent,
      Props: { ...inputProps.stateProvinceName, setInputProps, onCreated: handleInputCreated },
      ColumnSize: 6
    },
    { Input: TextComponent, Props: { ...inputProps.buyerAddress, setInputProps }, ColumnSize: 6 },
    ...(has("buyerContactPerson")
    ? [{ Input: TextComponent, Props: { ...inputProps.buyerContactPerson, setInputProps }, ColumnSize: 6 }]
    : []),

  ...(has("buyerContactNumber")
    ? [{ Input: TextComponent, Props: { ...inputProps.buyerContactNumber, setInputProps }, ColumnSize: 6 }]
    : []),

  ...(has("buyerSTRN")
    ? [{ Input: TextComponent, Props: { ...inputProps.buyerSTRN, setInputProps }, ColumnSize: 6 }]
    : []),

  ...(has("buyerCNIC")
    ? [{ Input: TextComponent, Props: { ...inputProps.buyerCNIC, setInputProps }, ColumnSize: 6 }]
    : []),
    { Input: HiddenComponent, Props: { ...inputProps.buyerRegistrationType, setInputProps }, ColumnSize: 6 },
    { Input: HiddenComponent, Props: { ...inputProps.sellerNTNCNIC, setInputProps }, ColumnSize: 6 }
  ];

  return (
    <div onKeyDown={(e) => e.stopPropagation()}>
      <StructuredGenerate
        mainProps={props}
        title={`Buyer - ${props.isAdd ? 'Add' : 'Edit'}`}
        Inputs={inputsList}
      />
    </div>
  );
};

export default BuyerAdd;